import styles from './Demo.module.scss';

const Demo = ({ context, valueA, valueB }) => {
  return (
    <span className={styles.root}>
      {valueA} / {valueB}
    </span>
  );
};

export default Demo;